export default {
  // URL: 'http://localhost:5000/api',
  // URL: 'https://socio-legal-api.ew.r.appspot.com/api',
  URL: 'https://sociolegal.es/api',
};
